<section class="accordion" [attr.aria-label]="ppTitle()">
  <button
    type="button"
    class="accordion__header"
    [attr.aria-expanded]="expanded()"
    (click)="toggle()"
  >
    <span class="accordion__title" ppTooltip [ppTrimTooltip]="true" [ppTitle]="ppTitle()">
      {{ ppTitle() }}
    </span>

    <span class="accordion__arrow" [class.accordion__arrow--collapsed]="!expanded()">
      <pp-icon [ppSrc]="EIconPath.ICON_MISC_DOWN_ARROW_24" ppClass="setSize24" ppColor="inherit" />
    </span>
  </button>

  @if (expanded()) {
    <div class="accordion__body">
      <ng-content />
    </div>
  }
</section>
